import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, of } from 'rxjs';
import { ILineupsAPI } from '../models';

@Injectable({
  providedIn: 'root',
})
export class MatchLineupsService {
  private http = inject(HttpClient);
  private env = environment;
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  isLoadingMatchStats = signal<boolean>(false);
  isErrorMatchStats = signal<boolean>(false);
  matchLineups = signal<ILineupsAPI | null>(null);

  constructor() {}

  getMatchLineups(matchId: String) {
    this.isLoadingMatchStats.set(true);
    this.isErrorMatchStats.set(false);

    this.http
      .get<ILineupsAPI | null>(
        `${this.env.baseUrlWeb}/matches/${matchId}/lineups`,
        {
          headers: this.headers,
        }
      )
      .pipe(
        catchError((_) => {
          this.isLoadingMatchStats.set(false);
          this.isErrorMatchStats.set(true);

          return of(null);
        })
      )
      .subscribe((data) => {
        if (!data) {
          this.matchLineups.set(null);
          return;
        }

        this.matchLineups.set(data);
        this.isLoadingMatchStats.set(false);
      });
  }
}
